import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';

export const preClassificationQuestions = clientName => [
    {
        id: 'notEmployee',
        answer_type: 'y/n',
        title: <FormattedMessage {...{ ...messages.prequalifyNotEmployee, values: { co: clientName } }} />,
        scoring: { n: -53, false: -53, y: 1, true: 1 }
    },
    {
        id: 'onsite',
        answer_type: 'y/n',
        title: <FormattedMessage {...{ ...messages.prequalifyOnsite, values: { co: clientName } }} />,
        scoring: { n: 1, false: 1, y: -30, true: -30 }
    },
    {
        id: 'directed',
        answer_type: 'y/n',
        title: <FormattedMessage {...{ ...messages.prequalifyDirected, values: { co: clientName } }} />,
        scoring: { n: 1, false: 1, y: -80, true: -80 }
    },
    {
        id: 'otherClients',
        answer_type: 'y/n',
        title: <FormattedMessage {...{ ...messages.prequalifyOtherClients, values: { co: clientName } }} />,
        scoring: { n: -1, false: -1, y: 40, true: 40 }
    },
    {
        id: 'ownHours',
        answer_type: 'y/n',
        title: <FormattedMessage {...messages.prequalifyOwnHours} />,
        scoring: { n: -20, false: -20, y: 20, true: 20 }
    }
];



// WEBPACK FOOTER //
// ./src/pages/approval/assets/preClassificationQuestions.jsx